(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mm-article-recommendations"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SELECTOR = '.mm-article-recommendations';
  var DESKTOP_QUERY = '(min-width: 750px)';
  var MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  function initSection(root) {
    if (!(root instanceof HTMLElement)) return;
    if (root.dataset.mmRecsInit === 'true') return;

    var viewport = root.querySelector('[data-mm-recs-viewport]');
    var track = root.querySelector('[data-mm-recs-track]');
    var nav = root.querySelector('[data-mm-recs-nav]');
    var prev = root.querySelector('[data-mm-recs-prev]');
    var next = root.querySelector('[data-mm-recs-next]');

    if (!viewport || !track) return;

    root.dataset.mmRecsInit = 'true';

    var desktopQuery = window.matchMedia(DESKTOP_QUERY);
    var motionQuery = window.matchMedia(MOTION_QUERY);
    var controller = new AbortController();
    var signal = controller.signal;
    var resizeFrame = 0;
    var scrollFrame = 0;

    function getStep() {
      var card = track.querySelector('[data-mm-recs-card]');
      if (!card) return 0;
      var gap = Number.parseFloat(window.getComputedStyle(track).columnGap);
      if (!Number.isFinite(gap)) gap = 0;
      return card.getBoundingClientRect().width + gap;
    }

    function getBounds() {
      var step = getStep();
      var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      var maxIndex = step > 0 ? Math.max(0, Math.round(maxScroll / step)) : 0;
      var index = step > 0 ? Math.round(viewport.scrollLeft / step) : 0;
      if (index < 0) index = 0;
      if (index > maxIndex) index = maxIndex;
      return { step: step, maxScroll: maxScroll, maxIndex: maxIndex, index: index };
    }

    function updateNav() {
      if (!nav) return;
      var count = Number(root.dataset.articleCount || '0');
      var visible = desktopQuery.matches ? 4 : 1;
      nav.classList.toggle('is-visible', count > visible);
    }

    function updateButtons() {
      var atStart = viewport.scrollLeft <= 1;
      var atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 1;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }

    function align() {
      var bounds = getBounds();
      if (bounds.step <= 0) return;
      var left = Math.min(bounds.index * bounds.step, bounds.maxScroll);
      if (Math.abs(viewport.scrollLeft - left) > 1) {
        viewport.scrollTo({ left: left, behavior: 'auto' });
      }
    }

    function move(direction) {
      var bounds = getBounds();
      if (bounds.step <= 0) return;
      var nextIndex = bounds.index + direction;
      if (nextIndex < 0 || nextIndex > bounds.maxIndex) return;
      viewport.scrollTo({
        left: Math.min(nextIndex * bounds.step, bounds.maxScroll),
        behavior: motionQuery.matches ? 'auto' : 'smooth',
      });
    }

    function onResize() {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(function () {
        updateNav();
        align();
        updateButtons();
      });
    }

    function onScroll() {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(updateButtons);
    }

    if (prev) {
      prev.addEventListener(
        'click',
        function () {
          if (prev.disabled) return;
          move(-1);
        },
        { signal: signal }
      );
    }

    if (next) {
      next.addEventListener(
        'click',
        function () {
          if (next.disabled) return;
          move(1);
        },
        { signal: signal }
      );
    }

    viewport.addEventListener('scroll', onScroll, { passive: true, signal: signal });
    desktopQuery.addEventListener('change', onResize, { signal: signal });

    var observer = new ResizeObserver(onResize);
    observer.observe(viewport);

    root._mmRecsDestroy = function () {
      controller.abort();
      observer.disconnect();
      window.cancelAnimationFrame(resizeFrame);
      window.cancelAnimationFrame(scrollFrame);
      delete root.dataset.mmRecsInit;
      root._mmRecsDestroy = null;
    };

    updateNav();
    updateButtons();
  }

  function initWithin(node) {
    var scope = node && node.querySelectorAll ? node : document;
    if (scope instanceof Element && scope.matches(SELECTOR)) initSection(scope);
    scope.querySelectorAll(SELECTOR).forEach(initSection);
  }

  function destroyWithin(node) {
    var scope = node && node.querySelectorAll ? node : document;
    var roots = [];
    if (scope instanceof Element && scope.matches(SELECTOR)) roots.push(scope);
    scope.querySelectorAll(SELECTOR).forEach(function (root) {
      roots.push(root);
    });
    roots.forEach(function (root) {
      if (typeof root._mmRecsDestroy === 'function') root._mmRecsDestroy();
    });
  }

  function onSectionLoad(event) {
    initWithin(event.target);
  }

  function onSectionUnload(event) {
    destroyWithin(event.target);
  }

  if (!window.__mmArticleRecommendationsBound) {
    window.__mmArticleRecommendationsBound = true;
    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:unload', onSectionUnload);
  }

  initWithin(document);
})();

  } catch(e) { console.error(e); }
})();
})();
